var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferReject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 20C9.485 20 5 15.515 5 10C5 4.485 9.485 0 15 0C20.515 0 25 4.485 25 10C25 15.515 20.515 20 15 20ZM16.6667 37.575C16.6667 34.755 17.765 32.1033 19.7583 30.11L23.7183 26.15C21.2583 24.3833 18.2533 23.3317 15 23.3317C6.73 23.3333 0 30.0633 0 38.3333C0 39.2533 0.746667 40 1.66667 40H16.6667V37.575Z",
    fill: "#17468C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 40L21 31L23.1213 28.8787L32.1213 37.8787L30 40Z",
    fill: "#17468C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 40L32 31L29.8787 28.8787L20.8787 37.8787L23 40Z",
    fill: "#17468C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferReject);
export default __webpack_public_path__ + "static/media/refer-reject.7bdf47df4fc12725e4a10bd5a47cc4cc.svg";
export { ForwardRef as ReactComponent };